import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ShippingService } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ShippingServiceService extends TmsWebBaseEditCreateService<ShippingService, ShippingService> {
  constructor() {
    super('ShippingService', $localize`Shipping Service`);
  }

  getForSupplier(id: string): Observable<ShippingService[]> {
    return this.httpService.get<ShippingService[]>(`${this.apiUrl}/GetForSupplier?id=${id}`);
  }
}
